import { Component, OnInit } from '@angular/core';
import { RoeV2Table } from '@app/modules/payroll/services';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views/index/index.view';

@Component({
    templateUrl: './roe-index.template.html',
    styleUrls: ['./roe-index.style.scss'],
})
export class RoeIndexView extends IndexView implements OnInit {
    isLoading = true;
    table: RoeV2Table;

    constructor(
        private auth: AuthService,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.table = new RoeV2Table(this.auth);
        this.isLoading = false;
    }

    onCreate(): void {}
}
